export default __webpack_public_path__ + "static/media/blueCircleDollarBold.e1c65e7f.svg";